module.exports = __webpack_public_path__ + "static/media/romwod.931c8966.svg";